export default "__VITE_ASSET__BECkJCMt__"